export default (theme) => ({
  mainContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    '& p': {
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 'auto'),
    },
  },
  icon: {
    marginRight: theme.spacing(1),
    height: '1.5rem',
  },
  regionPopup: {
    '&:after': {
      content: '""',
    },
  },
})
